<script>
import AddApplication from './addApplication.vue'
import AuthManage from './authManage.vue'
import { exportExcel } from '@/api/common'
import { apiOrganRoleAppBindPage, apiOrganRoleAppBindRemove } from '@/api/enterprise'
export default {
  name: 'ApplicationAuth',
  components: { AddApplication, AuthManage }, // 应用权限
  props: {
    roleUuid: {
      type: String,
      default: ''
    },
    roleName: {
      type: String,
      default: ''
    },
    roleTypeCode: {
      type: Number,
      default: null
    },
    readOnlyFlag: {
      type: [Boolean, Number],
      default: false
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      authVisible: false,
      moduleDataList: [],
      tableData: [],
      total: 0,
      page: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    disabled() {
      return this.roleTypeCode !== 1003502 || Boolean(this.readOnlyFlag)
    },
    disabledExport() {
      return this.disabled || this.tableData.length === 0
    }
  },
  watch: {
    roleUuid: {
      handler(val) {
        if (val) {
          this.getList()
        }
      }
    }
  },
  created() {
    if (this.roleUuid) {
      this.getList()
    }
  },
  methods: {
    async getList(state) {
      try {
        this.loading = true
        if (state !== 'page') this.page.pageNum = 1
        const res = await apiOrganRoleAppBindPage({
          roleUuid: this.roleUuid,
          page: this.page
        })
        this.tableData = res.data.list
        this.total = res.data.page.total
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    async removeAppRole({ appUuid, appName }) {
      // 移除应用
      try {
        await this.$confirm(`是否移除：${appName}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await apiOrganRoleAppBindRemove({
          roleUuid: this.roleUuid,
          appUuidList: [appUuid]
        })
        this.$message.success(res.msg)
        await this.getList('page')
      } catch (e) {

      }
    },
    setAuthManage({ moduleCode, appUuid }) {
      // 权限管理
      this.moduleDataList = [{ appUuid, moduleCode }]
      this.authVisible = true
    },
    selectApplication(val) {
      // table选择事件
      this.moduleDataList = val.map(i => {
        return {
          appUuid: i.appUuid,
          moduleCode: i.moduleCode,
          appName: i.appName,
          moduleCodeList: [],
          roleData: []
        }
      })
    },
    batchAuthManage() {
      // 批量权限管理
      if (Array.isArray(this.moduleDataList) && this.moduleDataList.length) {
        this.authVisible = true
      } else {
        this.$message.error('请选择应用')
      }
    },
    submitAuthManage() {
      this.moduleDataList = []
      this.getList('page')
    },
    async exportAuth() {
      const load = this.$load()
      try {
        const res = await exportExcel({
          progressParamData: { roleUuid: this.roleUuid },
          excelPath: '',
          progressBusinessCode: 1306201
        })
        this.$refs.export.operateProgressId = res.data.progressId
      } catch (e) {

      } finally {
        load.close()
      }
    }
  }
}
</script>

<template>
  <div v-loading="loading" class="app-auth">
    <div class="auth-operation">
      <el-button v-permission="['11203040203005']" type="primary" :disabled="disabledExport" @click="exportAuth">导出权限</el-button>
      <el-button v-permission="['11203040203006']" type="primary" :disabled="disabled" @click="batchAuthManage">批量权限管理</el-button>
      <el-button v-permission="['11203040203007']" type="primary" :disabled="disabled" style="margin-left: 20px" @click="()=>{visible = true}">添加应用</el-button>
    </div>
    <el-table class="app-table-data" :data="tableData" height="300px" @selection-change="selectApplication">
      <el-table-column type="selection" width="70" />
      <el-table-column type="index" width="80" label="序号" />
      <el-table-column label="应用名称" width="130" prop="appName" />
      <el-table-column label="应用描述" min-width="150" prop="appDescription" />
      <el-table-column label="操作" width="150">
        <template #default="{ row }">
          <el-button v-if="row.moduleCode" :disabled="readOnlyFlag" type="text" @click="setAuthManage(row)">权限管理</el-button>
          <el-button :disabled="readOnlyFlag" type="text" @click="removeAppRole(row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :background="false"
      :layout="'total, sizes, prev, pager, next, jumper'"
      :limit.sync="page.pageSize"
      :page.sync="page.pageNum"
      :total="total"
      @pagination="getList('page')"
    />
    <u-export ref="export" title="导出权限" style="margin-right: 20px" />
    <add-application v-model="visible" :role-uuid="roleUuid" :role-name="roleName" @submit="getList()" />
    <auth-manage v-model="authVisible" :role-uuid="roleUuid" :module-data="moduleDataList" @submit="submitAuthManage" />
  </div>
</template>

<style scoped lang="scss">
.app-auth{
  margin-top: 20px;
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  .auth-operation{
    position: absolute;
    top: -53px;
    right: 0;
  }
  .app-table-data{
    flex: 1;
    height: 100% !important;
  }
}
</style>
